module.exports = __webpack_public_path__ + "be4e639c59f5246330bb639b8d3ac0b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/jogo-do-bicho/trash.png
// module id = 1043
// module chunks = 0